import { router } from 'expo-router'
import { Routes } from '@/src/common/enums/routes'
import { openBrowserAsync } from 'expo-web-browser'
import { Platform } from 'react-native'

export const openInAppBrowser = (uri: string, title: string, type: 'window' | 'tab' = 'tab') => {
  if (Platform.OS !== 'web') {
    router.push({
      pathname: Routes.InAppBrowser.route,
      params: {
        uri,
        title,
      },
    })
    return
  }

  switch (type) {
    case 'tab':
      window.open(uri, title)
      break
    case 'window':
      return openBrowserAsync(uri)
  }
}
